<template>
    <cus-dialog :visible="showConfirm" :title="null" class="base-confirm" :close="closeUserProfile" isDisabledClose>
        <div slot="body" class="base-confirm-body">
            <div class="confirm-title base-flex">
                <span class="tipIcon">i</span>
                <span class="tipTitle base-text16">{{  $tran(title) || $tran('Tip') }}</span>
            </div>
            <div class="confirm-content" tabindex="0">{{ $tran(content) }}</div>
            <div class="confirm-footer base-flex-end">
                <cus-button @click="cancel" type="cancel" v-show="type.hideButton != `cancel`">{{ $tran('Cancel') }}</cus-button>
                <cus-button @click="confirm" type="confirm" v-show="type.hideButton != `OK`">{{ $tran('Confirm') }}</cus-button>
            </div>
        </div>
    </cus-dialog>
</template>

<script>
export default {
    name: 'CommonConfirm',
    data() {
        return {
            showConfirm: false, // Display confirmation pop-up window
            title: null,
            content: null,
            type: null
        }
    },
    methods: {
        showDialog(title, content, type) {
            /*
            type: is {type:'info',hideButton:'cancel'|'OK'} string define witch button to show
            */
            this.title = content;
            this.content = title;
            this.type = type;
            if(this.type == undefined)
            {
                this.type = {};
            }
            this.showConfirm = true;
        },
        closeUserProfile() {
            this.showConfirm = false;
        },
        cancel() {
            this.$emit('cancel');
            this.closeUserProfile();
        },
        confirm() {
            this.$emit('confirm');
            this.closeUserProfile();
        },
    },
}
</script>

<style scoped>
.base-confirm {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: 0;
    display: flex;
    overflow: auto;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99;
}
.base-confirm >>> .base-dialog-content {
    width: 526px;
}
.base-confirm-body {
    padding: 32px;
}
.confirm-title {
    height: 24px;
}
.base-confirm .tipIcon {
    margin: 0 2px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    background-color: var(--base-primary-color);
    color: var(--base-color-white);
}
.base-confirm .tipTitle {
    margin-left: 12px;
}

.confirm-content {
    margin-top: 16px;
    height: 60px;
    line-height: 20px;
}
.confirm-footer {
    margin-top: 12px;
}
.confirm-footer button+button {
    margin-left: 16px;
}
</style>